import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import type { PopoverPosition } from "@mui/material";
import { ListItemIcon, ListItemText, ListSubheader, Menu, MenuItem } from "@mui/material";
import type { SourceFigureTarget } from "./sourceRequestsState";

const reversedSignCaption = "Entries show the original sign; this number shows it reversed.";

interface Props {
  anchorPosition: PopoverPosition;
  sourceTitle: string;
  target: SourceFigureTarget;
  onOpenReport: (target: SourceFigureTarget) => void;
  onShowLedgerEntries: (target: SourceFigureTarget) => void;
  onClose: () => void;
}

const ArtifactFigureMenu = ({
  anchorPosition,
  sourceTitle,
  target,
  onOpenReport,
  onShowLedgerEntries,
  onClose,
}: Props) => {
  const isComputed = target.row === undefined;

  const handleOpenReportClick = () => {
    onClose();
    onOpenReport(target);
  };

  const handleShowLedgerEntriesClick = () => {
    onClose();
    onShowLedgerEntries(target);
  };

  return (
    <Menu
      open
      anchorReference="anchorPosition"
      anchorPosition={anchorPosition}
      onClose={onClose}
      slotProps={{ paper: { sx: { width: 320 } } }}
    >
      {isComputed && (
        <ListSubheader sx={{ lineHeight: 1.5, py: 1, bgcolor: "transparent" }}>
          Calculated by the dashboard from: {sourceTitle}
        </ListSubheader>
      )}
      <MenuItem onClick={handleOpenReportClick}>
        <ListItemIcon>
          <OpenInNewRoundedIcon />
        </ListItemIcon>
        <ListItemText
          primary="Open report"
          secondary={isComputed ? undefined : sourceTitle}
          slotProps={{ secondary: { noWrap: true } }}
        />
      </MenuItem>
      {target.drillDown && (
        <MenuItem onClick={handleShowLedgerEntriesClick}>
          <ListItemIcon>
            <ReceiptLongOutlinedIcon />
          </ListItemIcon>
          <ListItemText
            primary="Show ledger entries"
            secondary={target.drillDown.reversedSign ? reversedSignCaption : undefined}
            slotProps={{ secondary: { sx: { whiteSpace: "normal" } } }}
          />
        </MenuItem>
      )}
    </Menu>
  );
};

export default ArtifactFigureMenu;
